const courses = [
  {
    "id": "c59c9aa7-0d9f-4fdb-b3f8-e165e8819485",
    "title": "ICSE 8 Physics",
    "course_guid": "c59c9aa7-0d9f-4fdb-b3f8-e165e8819485",
    "version": "2.0.0.0",
    "root_node": 70160
  },
  {
    "id": "b6eab724-c1ae-4afb-9334-b2e7638a5792",
    "title": "ICSE 10 Physics",
    "course_guid": "b6eab724-c1ae-4afb-9334-b2e7638a5792",
    "version": "3.0.0.0",
    "root_node": 70161
  },
  {
    "id": "b01f67fd-c6fc-4562-81d6-42a0b9dfc547",
    "title": "CBSE 10 Maths",
    "course_guid": "b01f67fd-c6fc-4562-81d6-42a0b9dfc547",
    "version": "1.0.0.0",
    "root_node": 22647
  },
  {
    "id": "b0028c4b-7ada-4596-a978-a861bbf19777",
    "title": "ICSE 9 Chemistry",
    "course_guid": "b0028c4b-7ada-4596-a978-a861bbf19777",
    "version": "2.0.0.0",
    "root_node": 70279
  },
  {
    "id": "e339d133-d1d2-4fe2-ac9c-f5fedfe4354b",
    "title": "CBSE 6 Maths",
    "course_guid": "e339d133-d1d2-4fe2-ac9c-f5fedfe4354b",
    "version": "1.0.0.0",
    "root_node": 3216
  },
  {
    "id": "1246cefb-6882-4da0-9caf-2b28556b0616",
    "title": "CBSE 6 Physics",
    "course_guid": "1246cefb-6882-4da0-9caf-2b28556b0616",
    "version": "1.0.0.0",
    "root_node": 3207
  },
  {
    "id": "4c7952aa-106b-48e5-be34-6e3688337076",
    "title": "CBSE 10 Biology",
    "course_guid": "4c7952aa-106b-48e5-be34-6e3688337076",
    "version": "1.0.0.0",
    "root_node": 22705
  },
  {
    "id": "25023152-7b65-4f7a-8efb-a50d87155363",
    "title": "CBSE 8 Biology",
    "course_guid": "25023152-7b65-4f7a-8efb-a50d87155363",
    "version": "1.0.0.0",
    "root_node": 34100
  },
  {
    "id": "d8991159-bf6b-4a91-9650-bc822b8e4f18",
    "title": "ICSE 7 Maths",
    "course_guid": "d8991159-bf6b-4a91-9650-bc822b8e4f18",
    "version": "1.0.0.0",
    "root_node": 34471
  },
  {
    "id": "68aad001-f0f7-4793-b040-b5139f21a611",
    "title": "ICSE 7 Chemistry",
    "course_guid": "68aad001-f0f7-4793-b040-b5139f21a611",
    "version": "1.0.0.0",
    "root_node": 34182
  },
  {
    "id": "2eebb8b0-ba94-4501-8b5f-d0ae6ceb910c",
    "title": "CBSE 9 Chemistry",
    "course_guid": "2eebb8b0-ba94-4501-8b5f-d0ae6ceb910c",
    "version": "1.0.0.0",
    "root_node": 34221
  },
  {
    "id": "75bd8e12-259b-4599-ba3f-3b6391a1fabd",
    "title": "CBSE 8 Physics",
    "course_guid": "75bd8e12-259b-4599-ba3f-3b6391a1fabd",
    "version": "2.0.0.0",
    "root_node": 34013
  },
  {
    "id": "36f71949-b735-48ca-8f00-5b5f2fd9675d",
    "title": "CBSE 9 Maths",
    "course_guid": "36f71949-b735-48ca-8f00-5b5f2fd9675d",
    "version": "1.0.0.0",
    "root_node": 34316
  },
  {
    "id": "5fb4cb74-521f-45e8-9895-31facd664ba4",
    "title": "ICSE 6 Biology",
    "course_guid": "5fb4cb74-521f-45e8-9895-31facd664ba4",
    "version": "1.0.0.0",
    "root_node": 34144
  },
  {
    "id": "2082a7e4-0d11-4c9b-9bf5-4f4744eb048e",
    "title": "CBSE 7 Biology",
    "course_guid": "2082a7e4-0d11-4c9b-9bf5-4f4744eb048e",
    "version": "1.0.0.0",
    "root_node": 33900
  },
  {
    "id": "6fc786c1-9375-4238-88bc-83218caef5d5",
    "title": "Grade 5 Maths",
    "course_guid": "6fc786c1-9375-4238-88bc-83218caef5d5",
    "version": "1.0.0.0",
    "root_node": 7320
  },
  {
    "id": "66c0ba30-8aed-4088-89c2-d8c8c00c877a",
    "title": "ICSE 9 Biology",
    "course_guid": "66c0ba30-8aed-4088-89c2-d8c8c00c877a",
    "version": "3.0.0.0",
    "root_node": 104041
  },
  {
    "id": "b92353be-6b9a-4f46-9a8a-34dc2788e5ff",
    "title": "CBSE 10 Chemistry",
    "course_guid": "b92353be-6b9a-4f46-9a8a-34dc2788e5ff",
    "version": "1.0.0.0",
    "root_node": 22619
  },
  {
    "id": "5d6238b5-0b32-4c7f-86ea-f71843bad3b0",
    "title": "ICSE 8 Chemistry",
    "course_guid": "5d6238b5-0b32-4c7f-86ea-f71843bad3b0",
    "version": "2.0.0.0",
    "root_node": 70277
  },
  {
    "id": "73c33581-bc22-4c5d-899b-fa9a93aae692",
    "title": "CBSE 7 Physics",
    "course_guid": "73c33581-bc22-4c5d-899b-fa9a93aae692",
    "version": "1.0.0.0",
    "root_node": 33991
  },
  {
    "id": "2844c4fa-0a87-4ab3-a82a-96eff832377d",
    "title": "ICSE 8 Maths",
    "course_guid": "2844c4fa-0a87-4ab3-a82a-96eff832377d",
    "version": "2.0.0.0",
    "root_node": 70384
  },
  {
    "id": "0c9e6385-b92f-4680-96c4-dca9c684d13b",
    "title": "CBSE 8 Chemistry",
    "course_guid": "0c9e6385-b92f-4680-96c4-dca9c684d13b",
    "version": "2.0.0.0",
    "root_node": 34242
  },
  {
    "id": "44ef99ee-6180-423c-a77d-d422cad1519e",
    "title": "CBSE 8 Maths",
    "course_guid": "44ef99ee-6180-423c-a77d-d422cad1519e",
    "version": "1.0.0.0",
    "root_node": 34261
  },
  {
    "id": "f95a8252-9ff4-4f9b-8908-4b79686ea990",
    "title": "CBSE 10 Physics",
    "course_guid": "f95a8252-9ff4-4f9b-8908-4b79686ea990",
    "version": "1.0.0.0",
    "root_node": 22591
  },
  {
    "id": "996cd72f-5bb3-40f6-a84d-3f65bc3d6106",
    "title": "ICSE 9 Physics",
    "course_guid": "996cd72f-5bb3-40f6-a84d-3f65bc3d6106",
    "version": "5.0.0.0",
    "root_node": 70159
  },
  {
    "id": "6f89b1a3-04e3-4b38-8a5b-6beeebf0ea98",
    "title": "ICSE 10 Chemistry",
    "course_guid": "6f89b1a3-04e3-4b38-8a5b-6beeebf0ea98",
    "version": "3.0.0.0",
    "root_node": 70278
  },
  {
    "id": "b88814ce-4fb2-45f4-b9bf-043bc0e1f60e",
    "title": "Grade 5 Science",
    "course_guid": "b88814ce-4fb2-45f4-b9bf-043bc0e1f60e",
    "version": "1.0.0.0",
    "root_node": 7390
  },
  {
    "id": "3862a727-cfdf-4a06-ac12-e0890c7cadd3",
    "title": "Grade 4 Science",
    "course_guid": "3862a727-cfdf-4a06-ac12-e0890c7cadd3",
    "version": "1.0.0.0",
    "root_node": 7449
  },
  {
    "id": "5071bd82-bce9-4d3c-8626-195dfc142d85",
    "title": "ICSE 7 Physics",
    "course_guid": "5071bd82-bce9-4d3c-8626-195dfc142d85",
    "version": "1.0.0.0",
    "root_node": 34082
  },
  {
    "id": "99c9d626-1247-456f-83d8-e7118e0f5b9b",
    "title": "Grade 4 Maths",
    "course_guid": "99c9d626-1247-456f-83d8-e7118e0f5b9b",
    "version": "1.0.0.0",
    "root_node": 7262
  },
  {
    "id": "759908d4-9576-4b77-b3c5-1e36b53cec90",
    "title": "ICSE 9 Maths",
    "course_guid": "759908d4-9576-4b77-b3c5-1e36b53cec90",
    "version": "1.0.0.0",
    "root_node": 70385
  },
  {
    "id": "1e29bd13-da9b-48cc-a26a-cc8c077f57f4",
    "title": "CBSE 7 Maths",
    "course_guid": "1e29bd13-da9b-48cc-a26a-cc8c077f57f4",
    "version": "1.0.0.0",
    "root_node": 33935
  },
  {
    "id": "29ef46d5-e8e0-4802-bf3d-683044a574ff",
    "title": "CBSE 6 Chemistry",
    "course_guid": "29ef46d5-e8e0-4802-bf3d-683044a574ff",
    "version": "1.0.0.0",
    "root_node": 3194
  },
  {
    "id": "3d4c9119-c0c3-469e-92d9-c592dcf72086",
    "title": "CBSE 7 Chemistry",
    "course_guid": "3d4c9119-c0c3-469e-92d9-c592dcf72086",
    "version": "1.0.0.0",
    "root_node": 33920
  },
  {
    "id": "0dd8ea13-d8ac-40da-b245-fadc28173e3a",
    "title": "CBSE 6 Biology",
    "course_guid": "0dd8ea13-d8ac-40da-b245-fadc28173e3a",
    "version": "1.0.0.0",
    "root_node": 3181
  },
  {
    "id": "82a94f43-8d97-4642-aa9a-0437994610b5",
    "title": "ICSE 6 Maths",
    "course_guid": "82a94f43-8d97-4642-aa9a-0437994610b5",
    "version": "1.0.0.0",
    "root_node": 34370
  },
  {
    "id": "e01a0abc-c9f8-4793-a689-46089f1ff64a",
    "title": "CBSE 9 Physics",
    "course_guid": "e01a0abc-c9f8-4793-a689-46089f1ff64a",
    "version": "1.0.0.0",
    "root_node": 34039
  },
  {
    "id": "d779b964-69f5-47a6-b6b2-34f8c5fe7862",
    "title": "CBSE 9 Biology",
    "course_guid": "d779b964-69f5-47a6-b6b2-34f8c5fe7862",
    "version": "1.0.0.0",
    "root_node": 34124
  },
  {
    "id": "545ac8dc-1a82-449f-9e01-377b17069e62",
    "title": "ICSE 10 Biology",
    "course_guid": "545ac8dc-1a82-449f-9e01-377b17069e62",
    "version": "2.0.0.0",
    "root_node": 104042
  },
  {
    "id": "f8b7240f-33f7-4e10-861d-d8edfa69bdc0",
    "title": "ICSE 10 Maths",
    "course_guid": "f8b7240f-33f7-4e10-861d-d8edfa69bdc0",
    "version": "2.0.0.0",
    "root_node": 70386
  },
  {
    "id": "79db0003-fae0-4acb-bd49-edbbe26b9693",
    "title": "ICSE 6 Physics",
    "course_guid": "79db0003-fae0-4acb-bd49-edbbe26b9693",
    "version": "1.0.0.0",
    "root_node": 34065
  },
  {
    "id": "f7bf3110-eea0-4c7c-a0e7-397c60b65455",
    "title": "ICSE 8 Biology",
    "course_guid": "f7bf3110-eea0-4c7c-a0e7-397c60b65455",
    "version": "4.0.0.0",
    "root_node": 104043
  },
  {
    "id": "76b9e89c-1662-42a1-a4c2-4d0272befc99",
    "title": "ICSE 6 Chemistry",
    "course_guid": "76b9e89c-1662-42a1-a4c2-4d0272befc99",
    "version": "1.0.0.0",
    "root_node": 103676
  },
  {
    "id": "10c7c980-c44e-435f-a377-d9d5c8b61c3c",
    "title": "ICSE 7 Biology",
    "course_guid": "10c7c980-c44e-435f-a377-d9d5c8b61c3c",
    "version": "1.0.0.0",
    "root_node": 34165
  },
  {
    "course_guid": "c16badda-27c1-4283-acb0-acd125e750fd",
    "id": "c16badda-27c1-4283-acb0-acd125e750fd",
    "root_node": 317507,
    "title": "CBSE 10 Civics",
    "version": "1.0.0.0"
  },
  {
    "course_guid": "335a29a7-83eb-40de-a475-0f7dba7c7825",
    "id": "335a29a7-83eb-40de-a475-0f7dba7c7825",
    "root_node": 317506,
    "title": "CBSE 10 Economics",
    "version": "1.0.0.0"
  },
  {
    "course_guid": "22664845-bb63-4206-ac1d-631e1397d32c",
    "id": "22664845-bb63-4206-ac1d-631e1397d32c",
    "root_node": 317505,
    "title": "CBSE 10 Geography",
    "version": "1.0.0.0"
  },
  {
    "course_guid": "dcddee6d-58a6-4091-b841-91342c09e872",
    "id": "dcddee6d-58a6-4091-b841-91342c09e872",
    "root_node": 317508,
    "title": "CBSE 10 History",
    "version": "1.0.0.0"
  }
]

export const getCourse = (board,grade,subject)=>{
  const course_title = [board, grade, subject].join(" ");
  const course = courses.filter(c=>c.title.toLowerCase() === course_title.toLowerCase() )[0]
  return course
}